import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TasksReservation } from '@hkm/components/TaskManagement/models/reservations';
import InnerAccordion from '@hkm/components/TaskManagement/TaskPreview/LinkedObject/shared/InnerAccordion/InnerAccordion';
import SpecialNeeds from '@hkm/components/TaskManagement/TaskPreview/LinkedObject/shared/SpecialNeeds/SpecialNeeds';
import VipAndMember from '@hkm/components/TaskManagement/TaskPreview/LinkedObject/shared/VipAndMember/VipAndMember';

import { AcFormElement } from '@ac/mobile-components/dist/components/form-element';
import { AcIndicator } from '@ac/mobile-components/dist/components/indicator';
import { AcText } from '@ac/mobile-components/dist/components/text';
import { Color, Icon, TextSize } from '@ac/mobile-components/dist/enums';

interface ComponentProps {
  reservation: TasksReservation;
  index: number;
}

const RoomSharedReservationGuest = (props: ComponentProps) => {
  const { reservation, index } = props;
  const { t } = useTranslation();
  const guest = reservation.guestDetails;
  const hasVipOrMembership =
    guest!.vipStatusCode || !!reservation.memberships.length;
  const requireAccordion =
    !!guest!.disabilityCodes.length || hasVipOrMembership;

  const guestInfo = useMemo(
    () => (
      <>
        <AcText
          size={TextSize.Main2}
          className="ac-spacing-right-sm"
          testSelector={`task-accompanying-guest-name-${index}`}
        >
          {reservation.reservationGuestName}
        </AcText>

        {hasVipOrMembership && (
          <AcIndicator
            className="ac-spacing-right-sm"
            icon={Icon.Vip}
            backgroundColor={Color.Warning}
            testSelector={`task-shared-reservation-guest-vip-indicator-${index}`}
          />
        )}
        {reservation.hasDisability && (
          <AcIndicator
            icon={Icon.Disability}
            backgroundColor={Color.Alert}
            testSelector={`task-shared-reservation-guest-disability-indicator-${index}`}
          />
        )}
      </>
    ),
    [guest]
  );

  return (
    <>
      {requireAccordion ? (
        <InnerAccordion header={guestInfo} id={guest?.id || ''}>
          {hasVipOrMembership && (
            <AcFormElement
              label={t(
                'TASK_MANAGEMENT.TASK_PREVIEW.AREA.COMMON.VIP_AND_MEMBERSHIP'
              )}
              className="ac-spacing-top-md"
            >
              <VipAndMember
                vipStatusCode={guest!.vipStatusCode}
                memberships={guest!.disabilityCodes}
              />
            </AcFormElement>
          )}
          {reservation.hasDisability && (
            <AcFormElement
              label={t(
                'TASK_MANAGEMENT.TASK_PREVIEW.AREA.COMMON.SPECIAL_NEEDS'
              )}
            >
              <SpecialNeeds disabilityCodes={guest!.disabilityCodes} />
            </AcFormElement>
          )}
        </InnerAccordion>
      ) : (
        guestInfo
      )}
    </>
  );
};

export default RoomSharedReservationGuest;



// WEBPACK FOOTER //
// ./src/components/TaskManagement/TaskPreview/LinkedObject/shared/ReservationSharedReservationGuest/ReservationSharedReservationGuest.tsx